import { render, staticRenderFns } from "./AdminInquiry.vue?vue&type=template&id=e1a183e4&scoped=true&"
import script from "./AdminInquiry.vue?vue&type=script&lang=js&"
export * from "./AdminInquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a183e4",
  null
  
)

export default component.exports